module.exports = __webpack_public_path__ + "img/thumbnail_BorneanElephant_m_albino.b0cb3e64.png";